export default {
  share: {
    planCard: {
      viewPriceTable: '가격표 보기',
      facilityDetails: '시설 상세',
      soldOut: '매진',
      planAutoSwitchNotice:
        '{{date}}에는 「{{soldOutPlan}}」이(가) 매진되었습니다. 구매 가능한 「{{selectedPlan}}」을(를) 선택했습니다.'
    },
    activityCategory: {
      RAILWAY_TICKET: '철도 티켓',
      AIRPORT_TRANSPORTATION: '공항 철도',
      SHINKANSEN: '신칸센',
      EXPRESS_BUS: '고속버스',
      BUS_TOUR: '버스 투어',
      CRUISES: '크루즈',
      RENTAL_CAR: '렌터카',
      CHARTER: '전세 차량(택시)',
      ATTRACTION: '시설 티켓',
      THEME_PARK: '테마파크',
      MUSEUM_GALLERY: '뮤지엄 & 갤러리',
      AQUARIUM_ZOO: '수족관 & 동물원',
      TEMPLES_SHINES: '절 & 신사',
      TOWER_BUILDING: '타워 & 전망대',
      JAPANESE_RESTAURANT: '일식 레스토랑',
      WESTERN_RESTAURANT: '양식 레스토랑',
      CHINESE_RESTAURANT: '중식 레스토랑',
      OTHER_RESTAURANT: '기타 레스토랑',
      DESSERT_BEVERAGE: '디저트 & 드링크',
      SIGHTSEEING_TOUR: '관광 투어',
      MARINE_SPORTS: '해양 스포츠',
      OUTDOOR_ACTIVITIES: '야외 액티비티',
      ONSEN: '온천',
      SPA_MASSAGE: '스파 & 마사지',
      JAPANESE_CULTURAL_EXPERIENCE: '일본 문화 체험',
      JAPANESE_CRAFT_EXPERIENCE: '일본 공예 체험',
      JAPANESE_COOKING_EXPERIENCE: '일본 요리 체험',
      OTHER_EXPERIENCE: '체험 (기타)',
      HOTEL: '호텔',
      RYOKAN: '여관',
      VACATION_RENTAL: '민박',
      BUNDLE: '세트',
      PASS: '패스',
      OTHERS: '기타'
    },
    product: {
      planDateFallbackNotice:
        '선택하신 날짜({{selectedDate}})는 매진되었습니다. 구매 가능한 가장 가까운 날짜({{displayDate}})로 변경되었습니다. 날짜를 확인하신 후 구매해 주세요.',
      planAutoSwitchConfirmPlan: '선택한 플랜: {{planTitle}}',
      planAutoSwitchConfirmQuestion: '이대로 진행하시겠습니까?',
      switchLanguageTitle: '언어 변경'
    },
    priceTableDialog: {
      title: '가격표',
      dateFormat: '{{month}}월 {{day}}일 ({{weekday}})',
      weekdays: {
        0: '일',
        1: '월',
        2: '화',
        3: '수',
        4: '목',
        5: '금',
        6: '토'
      }
    },
    common: {
      account: '계정',
      myPage: '마이페이지',
      booking: '예약 내역',
      logout: '로그아웃',
      save: '저장',
      colon: ': ',
      multiply: '×',
      next: '다음',
      return: '돌아가기',
      toPay: '결제하기',
      update: '수정',
      search: '검색',
      delete: '삭제',
      space: ' ',
      comma: ',',
      titleSeparator: ' · ',
      add: '추가 구매',
      change: '변경',
      confirm: '확인',
      cancel: '취소',
      searchPlaceholder: '검색...',
      tilde: '~',
      showMore: '더 보기',
      notification: '알림',
      withParentheses: '{{value1}}（{{value2}}）',
      withDashSeparated: '{{val1}} - {{val2}}',
      selectTime: '시간을 선택해주세요'
    },
    price: {
      primary: '<currency>{{currency}}</currency> <amount>{{amount}}</amount>',
      prefix: '<currency>{{currency}}</currency><amount>{{amount}}</amount>',
      suffix: '<amount>{{amount}}</amount><currency>{{currency}}</currency>',
      jpyWord: 'JPY',
      cnyWord: 'CNY',
      jpySymbol: '¥'
    },
    footer: {
      terms: '이용약관',
      cert: '旅行業登録：東京都知事登録旅行業第2-8013号（リンクティビティ株式会社）',
      copyright: '{{year}} Copyright LINKTIVITY Inc.© All Rights Reserved.',
      recaptchaNotice:
        '이 사이트는 reCAPTCHA로 보호되며, Google의 <PrivacyLink>개인정보처리방침</PrivacyLink> 및 <TermsLink>서비스 약관</TermsLink>이 적용됩니다.'
    },
    validation: {
      required: '{{field}}는 필수 입력 항목입니다.',
      invalid: '유효한 {{field}}을 입력해주세요.',
      password:
        '대문자, 소문자, 특수문자, 숫자를 포함한 8자 이상의 비밀번호를 입력해주세요.',
      imageType: '이미지 파일을 선택해주세요.',
      fileSize: '{{size}}MB 이하의 파일을 선택해주세요.',
      range: '{{field}}는 {{min}}에서 {{max}} 사이의 값을 입력해주세요.',
      requiredSelect: '{{field}}을 선택해주세요.',
      nameInvalid: '{{field}}에 사용할 수 없는 문자가 포함되어 있습니다.',
      romajiOnly: '{{field}}은(는) 로마자로만 입력할 수 있습니다.',
      emailNotMatch: '이메일 주소가 일치하지 않습니다.',
      emailAlreadyRegistered:
        '해당 이메일 주소는 이미 등록되어 있습니다. 로그인 버튼을 통해 로그인해주세요.',
      ticketExpired: '구매 시간은 활동 시작 시간보다 늦을 수 없습니다.'
    },
    firebase: {
      'auth/wrong-password': '아이디 또는 비밀번호가 정확하지 않습니다.',
      'auth/user-not-found': '아이디 또는 비밀번호가 정확하지 않습니다.',
      'auth/email-already-in-use':
        '입력하신 이메일 주소는 이미 등록되어 있습니다.',
      'auth/too-many-requests':
        '로그인에 실패하였습니다. 잠시 후에 다시 시도하거나 비밀번호를 재설정 하여주시기 바랍니다.'
    },
    apiErrors: {
      baseError: '에러가 발생했습니다.',
      clientError: '요청에 오류가 발생했습니다.',
      serverError: '서버 요청에 실패하였습니다.',
      connectionError:
        '접속 에러가 발생했습니다. 통신 환경을 다시 한 번 확인하여 주시기 바랍니다.',
      requestError: '요청에 오류가 발생했습니다.',
      ARSError: {
        AFFILIATE_ID_REQUIRED:
          '작동 에러. 회원 한정 페이지에서부터 다시 접속으로 부탁드립니다.',
        BOOKING_NOT_ENOUGH_ALLOTMENT:
          '선택하신 날짜/시간은 현재 만석입니다. 다른 날짜/시간으로 다시 예약을 시도해 주시기 바랍니다.',
        BOOKING_NO_AVAILABILITY:
          '선택하신 날짜/시간은 현재 만석입니다. 다른 날짜/시간으로 다시 예약을 시도해 주시기 바랍니다.',
        PERMISSION_DENIED: '리소스 액세스 권한이 없습니다.',
        NOT_FOUND: '리소스를 찾을 수가 없습니다.',
        BOOKING_ALREADY_ISSUED: '티켓 발권/교환 후, 취소는 불가합니다.',
        BOOKING_RESERVATION_OVERLIMIT: '예약 가능 수를 초과하였습니다.',
        BOOKING_RATE_LIMITED:
          '현재 접속이 집중되고 있습니다.\n이용에 불편을 드려 죄송합니다.\n잠시 후 아래 ＜결제하기＞ 버튼을 통해 다시 진행해 주시기 바랍니다.'
      },
      lottery: {
        LOTTERY_ALREADY_APPLIED:
          '이 티켓은 1인 1회 구매만 가능합니다. 이미 신청이 완료되어 있습니다.'
      }
    },
    header: {
      openMenu: '메뉴 열기',
      closeMenu: '메뉴 닫기'
    },
    login: {
      title: '로그인／회원가입',
      caption: '로그인, 회원 가입 방법을 선택하여 주시기 바랍니다.',
      appleLogin: 'Apple',
      googleLogin: 'Google',
      email: '이메일 주소',
      emailConfirm: '이메일 주소(확인)',
      password: '비밀번호',
      button: '로그인',
      forgotPassword: '비밀번호를 잊으셨나요?',
      newAccount: '회원가입',
      signInAgree: `*타사 계정을 이용하여 간편 회원 가입 및 로그인을 하실 수 있습니다. \n *이메일 계정, 타사 계정을 이용하여 회원 가입하시는 경우는 <TermsLink>{{terms}}</TermsLink> 및 <PrivacyLink>{{privacy}}</PrivacyLink> 에 동의한 것으로 간주됩니다.`,
      otpErrorMsg: '인증 코드가 올바르지 않습니다. 다시 시도해 주세요.'
    },
    cart: {
      button: '장바구니',
      empty: '장바구니가 비어있습니다',
      addToCart: '장바구니에 추가',
      totalCount: '{{count}} 개 상품',
      totalAmount: '합계',
      unavailable: '구매 불가',
      deleteConfirm: '「{{activityName}}」을 삭제하시겠습니까?',
      availabilityConfirmTitle: '장바구니 내용 확인',
      availabilityConfirmContent:
        '장바구니에 판매 기간이 종료되었거나 품절된 상품이 포함되어 있습니다. 해당 상품을 삭제하고 결제를 계속하시겠습니까?',
      availabilityConfirmProceed: '삭제 후 계속',
      availabilityConfirmBack: '장바구니로 돌아가기'
    },
    payment: {
      ticket: '티켓',
      plan: '플랜',
      dateTime: '날짜 및 시간',
      validityPeriod: '유효 기간',
      option: '옵션',
      discount: '할인',
      total: '합계 (세액 포함)',
      details: '상세',
      submit: '주문하기',
      lotterySubmit: '추첨 신청',
      lotteryBeforeOpen: '추첨 접수 전',
      lotteryClosed: '추첨 접수가 종료되었습니다',
      numberOfPeople: '인원',
      totalWithTax: '합계 (세금 포함)',
      viewPlan: '플랜 보기',
      warn: '{{unitName}}만 단독 구매는 불가능합니다',
      optionRequiredTag: '필수',
      optionRequiredTip: '옵션 상품 선택은 필수입니다',
      optionQuantityShortage: '옵션 상품이 {{quantity}}명분 더 필요합니다',
      optionQuantityPartialShortage:
        '현재 선택 수량으로는 {{quantity}}명분이 더 필요합니다',
      optionQuantityExcess:
        '옵션 상품 합계가 플랜 수량을 {{quantity}}명분 초과했습니다',
      planQuantityRequired: '플랜의 참가 인원을 선택해 주세요'
    },
    password: {
      changePassword: '비밀번호 변경',
      resetPassword: '비밀번호 재설정',
      sendResetEmail: '비밀번호 재설정 메일을 발송하기',
      sendResetEmailSuccess:
        '비밀번호 재설정 URL이 {{email}}으로 발송되었습니다. 확인하고 비밀번호 재설정을 진행하여 주시기 바랍니다.',
      oldPassword: '이전 비밀번호',
      newPassword: '새로운 비밀번호',
      changePasswordSuccess: '비밀번호를 변경하였습니다.'
    },
    emailVerification: {
      title: '인증 메일을 발송했습니다',
      description: '{{email}}으로 인증 메일을 발송했습니다.',
      instruction: '메일에 기재된 인증 코드를 입력하여 등록',
      resend: '재발송',
      verify: '로그인'
    },
    date: {
      sunday: '일요일',
      monday: '월요일',
      tuesday: '화요일',
      wednesday: '수요일',
      thursday: '목요일',
      friday: '금요일',
      saturday: '토요일'
    },
    profile: {
      title: '개인정보',
      firstName: '이름',
      lastName: '성',
      email: '이메일',
      confirmEmail: '이메일(확인)',
      password: '비밀번호',
      gender: '성별',
      birthday: '생년월일',
      birthdayYear: '년',
      birthdayYearPlaceholder: '선택해 주세요',
      birthdayMonth: '월',
      birthdayDay: '일',
      birthdayYearOption: '{{value}}년',
      birthdayMonthOption: '{{value}}월',
      birthdayDayOption: '{{value}}일',
      country: '국가 또는 지역',
      prefecture: '도도부호',
      postCode: '우편번호',
      postCodePlaceholder: '예: 1234567 (하이픈 없이 7자리)',
      genderOptions: {
        male: '남성',
        female: '여성',
        other: '기타'
      },
      updateProfileSuccess: '개인정보를 성공적으로 업데이트했습니다.',
      updateProfileFailed:
        '개인정보 업데이트에 실패하였습니다. 나중에 다시 시도해주세요.',
      creditCardManagement: '신용카드 관리',
      creditCardManagementGetErrMsg:
        '신용카드 정보를 가져오는데 실패하였습니다.'
    },
    weeks: {
      sun: '일',
      mon: '월',
      tue: '화',
      wed: '수',
      thu: '목',
      fri: '금',
      sat: '토'
    },
    empty: {
      message: '콘텐츠를 찾을 수 없습니다.'
    },
    notFound: {
      subtitle: '이 페이지는 이용하실 수 없습니다.',
      returnHome: '홈으로 돌아가기'
    },
    notFoundAuth: {
      subtitle: '이 페이지는 이용하실 수 없습니다.'
    },
    details: {
      title: '상세 보기'
    },
    orderConfirm: {
      title: '구매 전 확인 사항 (중요)',
      agree: '위 내용을 확인하였으며 이에 동의합니다'
    },
    invoice: {
      title: '영수증 발급',
      info: '영수증 정보',
      name: '영수증 수령인',
      remarks: '비고',
      email: '영수증 받을 이메일 주소',
      check:
        '영수증은 예약당 한 번만 발급 가능합니다. 두 번 이상 발급 시 재발급되었음이 명시됩니다. 영수증 정보 및 수령인 등이 잘 기재되었는지 확인하신 후 발급해 주시기 바랍니다.',
      description: '품명/용도',
      cancelFee: '취소 수수료',
      cancelFeeAmount: '취소 수수료 총액',
      content: '영수증 내용',
      confirm: '전송 확인',
      success:
        '영수증이 정상적으로 발급되었습니다. 메일을 확인해 주세요: {{email}}',
      price: '지불 금액',
      refundAmount: '반환 금액'
    }
  },
  faq: {
    title: '자주 묻는 질문',
    bookingProcess: {
      title: '예약 진행',
      q1: '예약이 정상적으로 완료되었나요?',
      a1: `예약 확정시 등록된 메일 주소로 안내 메일을 보내드리고 있습니다. 이메일에 'E티켓 이용' 링크가 기재되어 있는 경우, 해당 링크에 접속하여 이용하시기 바랍니다.
  또한, 이메일 내 '예약 상세' 링크를 통해 예약 정보도 확인하실 수 있습니다.`,
      q2: '예약 확인 메일이 도착하지 않습니다. 어떻게 확인할 수 있을까요?',
      a2: `즉시 확정 상품은 5분 이내에 예약 확정/완료가 진행되며, 등록된 메일 주소로 안내 메일을 드리고 있습니다. 시간이 지나도 예약 확정 메일이 도착하지 않는 경우는 스팸 메일 폴더를 확인하여 주시기 바랍니다. '@linktivity.co.jp' 도메인으로 확정 메일이 전송됩니다.`,
      q3: '바우처 재발급이 가능한가요?',
      a3: `가능합니다. 예약하신 사이트에서 예약 정보와 바우처를 확인하실 수 있습니다.
1. 로그인 후 화면 우측 상단의 「마이페이지」 ＞ 「예약 정보」 클릭
2. 해당 예약의 「예약 상세 정보」 클릭
3. 바우처 정보란에서 원하는 바우처 클릭
「바우처 재발송」을 통해 등록하신 이메일 주소로 재발송도 가능합니다.`
    },
    payments: {
      title: '결제',
      q1: '결제 단계에서 예약 실패라는 문구가 표시됩니다.',
      a1: `예약 실패라는 문구가 표시된 경우, 약 5분 후 마이페이지의 예약정보를 한번 더 확인 해주시고, 예약이 확정 되지않았음을 확인 후 재예약해주시기 바랍니다.`,
      q2: '영수증 발행이 가능한가요?',
      a2: `영수증 발행은 현재 시스템에서는 지원을 하고 있지 않습니다. 
  다만, 개인용으로 필요하신 경우는 예약번호와 함께 <helpcenter@linktivity.co.jp>으로 문의하여 주시기 바랍니다.`,
      q3: '결제 수단은 어떤 것들이 있나요?',
      a3: `결제시 신용카드를 이용하실 수 있습니다.
  (Alipay, WeChat Pay로 결제 가능한 상품도 있습니다.)
  편의점 결제, 현금 결제는 불가한 점 양해바랍니다.`,
      q4: '3D시큐어란 무엇인가요?',
      a4: `3D시큐어는 인터넷에서 신용카드 결제를 보다 안전하게 하기 위한 본인인증 서비스입니다.
  신용카드 정보유출에 의한 명의도용 등 부정사용을 사전에 방지할 수 있습니다.
  3D시큐어에 등록된 신용카드로 결제할 경우, 주문 시 일회용 비밀번호 입력 등을 통해 카드 회원 본인 인증을 진행합니다. (카드사에 따라 인증 방법은 상이합니다.)`,
      q5: `3D시큐어 등록 방법을 알려주세요. 카드가 3D 시큐어를 지원하는지 모르겠습니다.`,
      a5: `3D시큐어는 사용하시는 카드사에 사전 등록을 하시면 이용하실 수 있습니다.
  카드 뒷면에 기재된 카드사 연락처를 통해 3D 시큐어 지원 여부 및 설정 방법에 대해 문의해 주시기 바랍니다.`,
      q6: `3D시큐어 비밀번호를 모르겠어요. 3D시큐어 일회용 비밀번호를 받지 못했어요.`,
      a6: `3D시큐어 인증 화면에서 필요한 비밀번호는 카드사에 사전 등록하신 비밀번호 또는 일회용 비밀번호입니다.
  일회용 비밀번호가 도착하지 않는 경우, 스팸메일 폴더에 도착했을 가능성이 있으니 스팸메일 폴더를 확인하시기 바랍니다.
  비밀번호를 모르시거나 일회용 비밀번호를 받지 못한 경우, 카드 뒷면에 기재된 카드사 연락처로 문의해 주시기 바랍니다.`,
      q7: `3D시큐어 인증가능한 신용카드만 사용할 수 있나요?`,
      a7: `3D시큐어 인증불가한 카드는 사용할 수 없습니다. 보안을 위해 필히 양해 부탁드립니다. *최근 카드부정사용이 급증함에 따라 일본 경제산업성은 2025년 3월 말부터 전자상거래 사이트에 본인인증(EMV 3-D 시큐어) 도입을 의무화한다고 발표했습니다.
  또한 2023년 3월에 발행된 '신용카드 보안 가이드라인【4.0판】'에는 EC사업자, 카드사 및 결제대행사업자를 대상으로 '본인인증 도입 의무화 및 이에 대한 대응'이라는 내용이 추가되었습니다. 새로운 인터넷 예약 시스템에서는 이 가이드라인에 따라 3D 시큐어를 필수로 하는 결제 시스템을 도입하고 있습니다.`,
      q8: `직불카드(체크카드)도 사용할 수 있나요?`,
      a8: `네, 가능합니다.`,
      q9: '3D 보안 설정이나 카드 이용 한도에도 문제가 없고, 다른 웹사이트에서는 항상 사용할 수 있는 카드인데도 오류가 발생해 결제가 되지 않습니다.',
      a9: `카드에 문제가 없는데도 결제가 되지 않는 경우, 카드사의 결제 승인 시스템이 '부정사용 의심 등'으로 판단하여 고객의 카드를 보호하기 위해 결제를 중단했을 가능성이 있습니다.
  사람의 판단과 달리 컴퓨터는 여러 가지 요소를 예측하여 판단을 하기 때문에 경우에 따라 결제 불가로 처리되는 경우가 있습니다.
  번거로우시겠지만, 다음 중 하나를 시도해 보시기 바랍니다.
  ・다른 카드로 결제 시도하기
  ・시간을 두고 다시 결제 시도하기
  ・카드사에 연락후 예약하고자 하는 티켓명과 상황을 설명해 주시고, 카드사 측에서 오류를 제거할 수 있도록 부정사용 감지 및 결제 승인 시스템 수정을 요청하기`,
      q10: '카드사로부터 이용 알림이 왔는데 마이페이지에 예약 정보가 없고, 예약 확정 메일도 오지 않습니다.',
      a10: `다음 중 한 가지 상황일 수 있습니다.
  ・이메일 주소 입력 오류(맞춤법 오류)
  ・평소 사용하던 이메일 주소와 다른 이메일 주소로 예약을 등록한 경우
  ・결제 및 예약이 미완료된 경우(카드 한도액 확보 단계까지는 진행되었으나, 일련의 오류로 인해 결제 및 예약이 미완료된 경우)
  혹시 기억나는 이메일 주소가 있다면, 해당 이메일 주소로 마이페이지에 로그인을 시도해 보시기 바랍니다.
  로그인할 수 없는 경우, 결제 및 예약 기록을 조회할 수 있도록 아래 정보를 기재하여 LINKTIVITY 고객지원팀<helpcenter@linktivity.co.jp>으로 메일을 보내주시기 바랍니다.
  -예약자 이름(영문):
  -참가 희망일:
  -결제하신 날짜 및 시간대(예: 3/2 19:00):
  -결제하신 카드 뒷자리 3자리:
  -결제한 카드의 유효기간:
  -금액:
  -예약에 사용했을 가능성이 있는 이메일 주소:`
    },
    changesAndCancellations: {
      title: '예약 변경 및 취소',
      q1: '예약을 잘못한 경우는 어떻게 해야 하나요?',
      a1: `취소가 가능한 상품의 경우는 하기와 같이 진행하여 주시기 바랍니다. 
  1. 계정 로그인 후 화면 상단 오른쪽 '마이페이지', '예약 상세'를 클릭하여 주십시오.
  2. 해당 예약의 '상세 보기'를 클릭하여 주십시오.
  3. 취소 정보에 있는 '취소 시작'을 클릭 후, '취소'를 클릭하시면 취소가 완료됩니다.`,
      q2: '취소하면 환불은 언제쯤 받아볼 수 있나요?',
      a2: `취소 수속 후 신용 카드 회사에 따라 환불 시기가 다를 경우가 있습니다. 정확한 환불 시기는 결제시 이용한 신용카드 회사로 문의를 부탁드립니다.`,
      q3: '예약 내용 변경이 가능한가요?',
      a3: `예약 내용 변경이 불가능합니다. 취소가 가능한 상품의 경우는 취소 후 재 예약을 진행하여 주시기 바랍니다. 
  상품 페이지 취소 정책을 참조하여 주시기 바랍니다.`
    },
    accounts: {
      title: '회원가입/계정',
      q1: '신규 회원 등록 방법을 알려주세요.',
      a1: `사이트 상단 오른쪽 '로그인'을 클릭하거나, 상품 예약 시 신규 회원 등록이 가능합니다. 
  현재 저희 사이트는 애플이나 구글등을 통한 계정 등록만 가능합니다.`,
      q2: '로그인 방법을 알려주세요.',
      a2: `예약한 사이트 상단 오른쪽에 '로그인'을 클릭하여 진행하여 주시기 바랍니다.`,
      q3: '비밀 번호를 잊어버렸습니다. 어떻게 해야하나요?',
      a3: `로그인 페이지에서 '비밀번호 찾기'를 클릭하시고 비밀번호 재설정을 진행하여 주시기 바랍니다.`
    },
    environment: {
      title: '기타',
      q1: '추천 브라우저를 알려주세요.',
      a1: `・Firefox(최신판)
  ・Safari(최신판)
  ・Google Chrome(최신판)`,
      q2: '예약 확인 메일 발신자를 알려주세요.',
      a2: `'@linktivity.co.jp' 도메인을 사용하여 예약 확인 메일을 발송하고 있으며, 스팸 메일등으로 분류 되는 경우가 있기에 사전에 지정 수신 설정을 부탁드립니다.`
    },
    ticket: {
      title: 'E-ticket 이용',
      q1: '원타임 패스워드 인증이란 무엇인가요?',
      a1: `본 예약 시스템에서는 고객의 접속 환경(단말기, 브라우저 등)이 변경된 경우 일회용 비밀번호(1회용 비밀번호)를 이용하여 인증하여 제3자에 의한 디지털티켓의 부정사용을 방지합니다.
  E-ticket 이용시 사용하는 접속 환경과 다른 접속 환경에서 E-ticket 이용전 열람한 경우, 이 인증이 이루어집니다.
  당일 이용 시 당황하지 않도록 당일 이용할 단말기와 브라우저에서 E-Ticket을 미리 열어 확인하는 것을 권장합니다.
  예시:
  첫번째, A씨가 스마트폰으로 전자티켓을 열었을 때:원타임 패스워드 인증이 불필요
  두번째, A씨가 가족의 스마트폰으로 E-ticket을 열었을 때: 첫 번째와 다른 기기이므로 원타임 패스워드 인증을 요청하는 화면이 표시
  이때 입력한 이메일 주소가 시스템에 등록되고(고정), 세번째 다른 단말기로 열었을 때에도 이때 등록한 이메일 주소로 원타임패스워드가 전송됩니다. 따라서 이용 당일에도 현지에서 확인할 수 있는 이메일 주소로 원타임 패스워드를 보내는 것을 추천합니다.`,
      q2: `갑자기 '고객의 접속 환경이 변경되었습니다'라는 메시지가 떴습니다. 어떻게 E-ticket을 볼 수 있나요?`,
      a2: `고객님의 접속 환경이 변경되어(E-ticket을 처음 열었던 단말기와 다른 단말기 또는 다른 브라우저에서 열렸기 때문에) 원타임 패스워드 인증이 필요한 상태입니다. 메시지가 표시되면 먼저 원타임 패스워드를 보낼 이메일 주소를 입력해 주세요. 당일 현장에서도 확인할 수 있는 이메일 주소를 입력해 원타임 패스워드를 전송하는 것을 추천합니다. 입력한 이메일 주소로 원타임 패스워드가 도착했는지 확인후 메일 본문에 기재된 원타임 패스워드를 입력하세요. 비밀번호를 올바르게 입력하면 인증이 완료되고 E-티켓을 볼 수 있습니다.`,
      q3: '원타임 패스워드 메일을 받지 못했습니다.',
      a3: `원타임 패스워드 메일이 도착하지 않는 경우, 스팸메일함을 확인해 주세요. 또한, 도메인을 지정한 경우 '@linktivity.co.jp'를 허용하도록 설정해 주시기 바랍니다. 그래도 수신이 되지 않는다면, 이메일 주소가 잘못되었을 가능성이 있습니다. 올바른 이메일 주소를 입력하거나 다른 이메일 주소를 시도해 보세요.`,
      q4: '원타임 패스워드를 보낼 이메일 주소를 변경할 수 있나요?',
      a4: `원타임 패스워드를 보내는 이메일 주소는 변경할 수 없습니다. 원타임 패스워드 인증이 완료되면 이후부터는 등록한 이메일 주소로 일회용 비밀번호가 발송됩니다. E-ticket을 이용할 단말기(당일 현지에 가져갈 스마트폰 등)에서 확인할 수 있는 이메일 주소를 등록하는 것을 추천한다.`,
      q5: '보낸적이 없는 원타임 패스워드 메일을 여러 번  받았습니다.',
      a5: `다음과 같은 가능성이 있습니다.
  ・동반자에게 E-ticket(바우처)을 전송한 경우:
  고객이 E-ticket을 열고 원타임 패스워드 인증을 한 후, 동반자가 E-ticket을 열려고 하면 다른 단말기이므로 원타임 패스워드 메일이 전송됩니다.
  이때, 일회용 비밀번호의 발송처가 고객님의 이메일 주소(일회용 비밀번호 인증 시 등록한 이메일 주소)로 고정되어 있기 때문에 동반자가 E-Ticket에 접속한 시점에 여러 번 메일이 발송될 수 있습니다.
  
  ・부정사용:  만약 동반자에게 티켓을 전송하지 않은 경우, 부정사용의 가능성이 있으므로, 검토 후 필요시 예약 취소후 재예약을 권해드립니다.`,
      q6: '모르는 이메일 주소로 원타임 패스워드가 발송되었습니다.',
      a6: `다음과 같은 가능성이 있습니다.
  ・동반자에게 E-ticket(바우처)을 전송한 경우:
  고객이 E-ticket을 열고 원타임 패스워드 인증을 한 후, 동반자가 E-ticket을 열려고 하면 다른 단말기이므로 원타임 패스워드 메일이 전송됩니다.
  이때, 일회용 비밀번호의 발송처가 고객님의 이메일 주소(일회용 비밀번호 인증 시 등록한 이메일 주소)로 고정되어 있기 때문에 동반자가 E-Ticket에 접속한 시점에 여러 번 메일이 발송될 수 있습니다.
  
  ・부정사용: 만약 동반자 이외의 메일 주소로 전송된 경우, 부정사용의 가능성이 있으므로, 검토 후 필요시 예약 취소후 재예약을 권해드립니다.`
    }
  },
  privacy: {
    lastUpdated: '최종 업데이트: 2022년 3월 18일',
    companyName: 'Linktivity Inc.',
    title: '개인정보 처리방침',
    personalInfoProtectionPolicy: '개인정보 보호 정책',
    personalInfoProtectionDescription:
      'Linktivity Inc.(이하 "회사")는 예약 웹사이트 LINKTIVITY 등을 통해 고객으로부터 개인정보를 수집합니다. 회사는 고객이 안심하고 편리하게 예약할 수 있도록 고객 개인정보를 보호하는 것이 매우 중요하다고 생각하며, 다음에 명시된 규정을 준수하여 개인정보를 처리합니다.',
    customerDataManager: '고객 데이터 관리자',
    companyAddress:
      '일본 도쿄도 치요다구 우치사이와이초 2-1-6 히비야 파크프론트 19층',
    acquisition: '수집',
    acquisitionDescription:
      '회사는 법령에서 필요한 경우 고객의 동의를 얻은 후 명시된 이용 목적을 달성하기 위해 필요한 최소한의 개인정보만을 수집합니다.',
    usage: '이용',
    usageDescription:
      '회사는 고객으로부터 수집한 개인정보를 명시된 이용 목적을 달성하기 위해서만 이용합니다.',
    storage: '보관 및 저장',
    storageDescription:
      '회사는 고객으로부터 수집한 개인정보가 외부로 유출되지 않도록 시스템 보안을 주의하여 개인정보를 보관 및 저장합니다.',
    destruction: '파기 및 삭제',
    destructionDescription:
      '회사는 더 이상 필요하지 않은 개인 데이터를 필요 없어진 시점에서 지체 없이 파기합니다.',
    customerInquiry: '고객 문의에 대한 대응',
    customerInquiryDescription:
      '회사는 고객이 보유한 개인 데이터의 이용 목적 통지 요청, 공개 요청, 정정/추가/삭제 요청, 이용 중단/삭제 요청 및 제3자 제공 중단 요청에 대해 관련 법령에 따라 대응합니다.',
    safetyMeasures: '안전 관리 조치',
    safetyMeasuresDescription:
      '회사는 LINKTIVITY 서비스에 관련된 모든 직원이 개인정보의 중요성을 이해하도록 교육하고, 개인정보 보호를 위해 필요하고 적절한 조치를 취합니다.',
    tableOfContents: '목차',
    policy1: {
      title: '회사가 수집하는 개인정보 및 이용 목적',
      description:
        '회사는 다음에 명시된 이용 목적으로 고객의 주소, 이름, 생년월일, 연락처, 이메일 주소, 여권 번호 등의 개인정보를 수집하고 이용합니다. 회사는 고객의 동의 없이 민감한 개인정보를 수집하지 않습니다. 개인정보 수집 시점에 개인정보의 이용 목적이 공개되지 않은 경우, 회사는 고객에게 이용 목적을 통지하거나 공개합니다. 회사는 부모의 동의 없이 13세 미만의 아동으로부터 개인정보를 수집하지 않습니다. 13세 미만의 아동 개인정보를 제공하는 경우, 부모의 동의를 얻은 것으로 간주하지만, 동의를 얻지 못했음이 명확해지면 부모에게 연락하고 관련 목적 외에는 개인정보를 이용하지 않습니다.',
      serviceUsage: {
        title: 'LINKTIVITY 서비스 이용(회원 가입 등)',
        description:
          'LINKTIVITY 서비스 이용을 위해 고객 개인정보는 회사 내부에서 공유됩니다.',
        legalBasis: '고객이 요청한 서비스 및 기능을 제공하기 위해 필요합니다.'
      },
      ticketPurchase: {
        title: '티켓 구매 신청',
        infoItems:
          '회사는 상품 제공업체로부터의 티켓 구매 신청을 처리할 때 고객의 이름, 결제 정보, 여권 번호 및 건강 상태와 병력을 포함한 고객의 건강 상태 관련 정보를 수집합니다.',
        purpose:
          '회사는 고객 개인정보를 수집하여 상품 제공업체로부터의 티켓 구매 자격을 확인하고 티켓 및 관련 수수료의 결제를 처리합니다. 이 목적을 위해 회사는 고객 개인정보를 상품 제공업체, 운송 회사, 결제 처리업체 및 기타 서비스 제공업체(해외 제공업체 포함)에 제공할 수 있습니다.',
        legalBasis: '고객이 요청한 서비스 및 기능을 제공하기 위해 필요합니다.'
      },
      newsletter: {
        title: '뉴스레터(이메일 매거진 등) 전송 및 고객 통신',
        legalBasis: '고객의 동의에 기반하여 수집합니다.'
      },
      advertising: {
        title: '소셜 미디어 및 광고 배포 플랫폼을 통한 광고',
        legalBasis: '고객의 동의에 기반하여 수집합니다.'
      },
      survey: {
        title: '설문조사 참여 요청',
        legalBasis:
          '예약 웹사이트, 상품 및 서비스 개선을 위해 고객의 동의에 기반하여 수집합니다.'
      },
      analysis: {
        title: '고객 정보 분석 및 관리',
        legalBasis:
          '예약 웹사이트, 상품 및 서비스를 개선함으로써 고객의 정당한 이익을 추구하고 보호하기 위해 필요합니다.'
      },
      fraudDetection: {
        title: '신용카드 등의 부정 사용 탐지',
        legalBasis:
          '고객의 신용카드 보안을 보장하고 고객의 정당한 이익을 추구하기 위해 필요합니다.'
      }
    },
    policy2: {
      title: '개인 데이터의 제3자 제공',
      description:
        '회사는 다음의 경우를 제외하고 고객으로부터 수집한 개인 데이터를 제3자에게 제공하지 않습니다.',
      case1:
        '고객이 본 개인정보 처리방침 또는 기타 수단을 통해 제3자(상품 제공업체, 해외 여행사, 소셜 미디어 제공업체, 광고 배포 서비스 회사 등)에게 개인 데이터 제공에 사전 동의한 경우',
      case2:
        '명시된 이용 목적을 달성하는 데 필요한 범위 내에서 개인 데이터 처리를 제3자에게 위탁한 경우',
      case3: '법령에 기반하여 제공을 요청받은 경우',
      case4:
        '인명, 신체 또는 재산 보호를 위해 필요하고 고객의 동의를 얻기 어려운 경우',
      case5:
        '공중 보건 증진 또는 아동의 건전한 발달 추진을 위해 특히 필요하고 고객의 동의를 얻기 어려운 경우',
      case6:
        '정부 또는 지방 정부가 법령에 규정된 업무 수행을 위해 협력이 필요하고 고객의 동의를 얻으면 해당 업무 수행에 지장을 줄 수 있는 경우'
    },

    policy3: {
      title: '개인 데이터 처리의 위임',
      description:
        '회사가 명시된 이용 목적을 달성하는 데 필요한 범위 내에서 고객 개인 데이터 처리를 제3자에게 위임할 때, 회사는 위임받은 기관에 필요하고 적절한 감시를 제공합니다. 위임받은 기관이 다른 기관으로 재위임하는 경우, 회사는 위임받은 기관이 재위임 기관에 필요하고 적절한 감시를 제공하는지 직접 또는 간접적으로 감시합니다. 재위임 기관이 다시 위임하는 경우도 동일하게 적용됩니다.'
    },
    policy4: {
      title: '쿠키 정보 등의 수집',
      cookie: {
        title: '쿠키',
        description1:
          '쿠키는 사용자에 대한 정보를 포함하고 사용자의 하드드라이브에 저장되는 데이터 파일입니다. 회사는 쿠키를 개인 식별에 사용하지 않습니다. 쿠키는 세션 쿠키이며 사용자가 브라우저를 닫으면 보관되지 않습니다. 쿠키는 고객 서비스 개선, 웹사이트 커스터마이제이션, 광고 효과 측정 등의 목적으로 사용됩니다.',
        description2:
          '회사는 쿠키를 통계 데이터로 분석하여 고객의 관심사를 파악하고 활용합니다. 쿠키는 또한 무단 접근 방지에도 사용됩니다.',
        description3:
          '쿠키는 고객의 선호도에 따라 비활성화할 수 있지만, 이렇게 하면 고객은 LINKTIVITY에서 예약할 수 없습니다.'
      },
      logFile: {
        title: '로그 파일',
        description1:
          '회사는 특정 정보를 자동으로 수집하여 로그 파일에 저장합니다. 이 정보에는 IP(인터넷 프로토콜) 주소, 브라우저 유형, ISP(인터넷 서비스 제공업체) 이름, 참조/종료 페이지, 운영 체제 및 날짜/타임스탬프가 포함됩니다. 회사는 이 정보를 무단 접근 모니터링 및 고객 트렌드 분석, 웹사이트 관리, 고객 행동 추적에 사용합니다.',
        description2:
          '그러나 회사는 이 정보를 개인을 식별할 수 없는 방식으로 사용하며, 수집한 정보를 위에 명시된 목적 이외의 목적으로 사용하지 않습니다.'
      },
      webBeacon: {
        title: '웹 비콘',
        description:
          '회사는 웹 비콘을 접근 분석 및 제휴 프로그램을 위해 사용합니다. 회사는 웹 비콘을 위에 명시된 목적 이외의 목적으로 또는 개인 식별을 위해 사용하지 않습니다.'
      },
      statisticalAnalysis: {
        title: '통계 분석',
        description1:
          '회사는 제3자 접근 분석 도구를 사용하여 어느 사이트와 서비스가 인기 있는지 파악하고 LINKTIVITY 내에서 고객이 접근한 페이지와 페이지 기록을 기록합니다.',
        description2:
          '회사는 이 데이터를 사용하여 특정 분야에 관심을 보인 고객에게 LINKTIVITY 내에서 고객의 관심에 맞는 콘텐츠와 광고를 제공합니다.',
        description3:
          '회사는 또한 개인을 식별하지 않는 통계 정보를 수집할 수 있습니다. 또한 회사가 수집한 쿠키 정보와 다른 기관이 수집한 쿠키 정보를 제3자 접근 분석 도구 플랫폼에서 양쪽이 볼 수 있도록 할 수 있습니다.'
      }
    },
    policy5: {
      title: '익명 처리된 정보의 처리',
      creation: {
        title: '익명 처리된 정보의 작성',
        description1:
          '회사는 익명 처리된 정보를 작성할 때 다음 조치를 취합니다. 익명 처리된 정보는 법령 요구 사항에 따라 특정 개인을 식별할 수 없는 방식으로 개인정보를 처리하여 얻은 개인 관련 정보이며, 원본 개인정보를 복구할 수 없도록 합니다.',
        description2:
          '① 법령이 규정한 기준에 따라 적절하게 처리함 ② 법령이 규정한 기준에 따라 삭제된 정보 및 처리 방법 관련 정보의 공개를 방지하기 위한 안전 관리 조치를 시행함 ③ 작성된 익명 처리된 정보에 포함된 개인 관련 정보의 항목을 공개함 ④ 익명 처리된 정보 작성에 사용된 개인정보로부터 원본 개인을 식별하기 위한 조치를 취하지 않음'
      },
      provision: {
        title: '익명 처리된 정보의 제공',
        description:
          '회사가 익명 처리된 정보를 제3자에게 제공할 때, 회사는 익명 처리된 정보에 포함된 개인 관련 정보의 항목과 제공 방법을 공개하고 수신자에게 제공되는 정보가 익명 처리된 정보임을 명시합니다.'
      },
      disclosure: {
        title: '익명 처리된 정보에 대한 공개',
        creationSubtitle: '익명 처리된 정보 작성',
        creationDescription:
          '회사가 보유한 다음 고객 개인정보에 대해 회사는 특정 개인을 식별하지 않고 원본 개인정보를 복구할 수 없도록 적절한 조치를 취한 후 지속적으로 익명 처리된 정보를 작성합니다.',
        itemsTitle: '익명 처리된 정보에 포함된 개인 관련 정보의 항목',
        itemsDescription:
          '플랫폼 서비스 제공과 관련하여 수집된 정보: 구매 날짜, 참가 날짜, 바우처 언어, 판매 금액 범위, 참가자 수, 예약 상태(확정 또는 취소됨), 공급업체 위치 및 도도부현 정보, 여행사 위치 국가.',
        thirdPartyTitle: '익명 처리된 정보의 제3자 제공',
        thirdPartyDescription:
          '회사가 작성하거나 보유한 익명 처리된 정보에 대해 회사는 정보가 익명 처리된 정보임을 명시하면서 지속적으로 제3자에게 제공합니다.',
        provisionMethod:
          '암호로 보호된 전자 파일을 전자 통신 수단(이메일, 서버 업로드, API 통합 등) 또는 물리 미디어(DVD 등)를 통해 전송.'
      }
    },
    policy6: {
      title: '개인 데이터의 안전 관리 조치',
      description1:
        '회사는 개인 데이터의 유출, 절도, 오용, 무단 접근, 변조 및 파괴를 방지하기 위해 조직적, 기술적, 물리적 안전 관리 조치를 시행합니다. 회사가 개인 데이터를 저장하는 서버에 대한 접근은 ID 및 비밀번호 접근 권한이 있는 승인된 직원으로 제한되며, 특정 개인 데이터에 대한 접근은 데이터 관리를 위해 필요한 최소한의 직원에게만 부여됩니다.',
      description2:
        '또한 신용카드 정보를 포함한 개인 데이터는 여러 데이터 센터에 분산되어 보안 환경에 저장됩니다. 회사는 예약 거래와 관련된 모든 페이지에 대해 보안 소켓 레이어(SSL) 암호화를 사용합니다. SSL 준수 브라우저를 사용하면 인터넷을 통해 전송되는 개인 데이터 및 신용카드 정보의 기밀성을 유지할 수 있습니다.',
      description3:
        '고객 개인 데이터를 처리하는 회사 직원은 터미널을 떠날 때 암호로 보호된 화면 보호기를 사용합니다.',
      description4:
        '또한 회사는 특정 부서는 월 1회, 전사적으로는 최소 연 2회 이상의 빈도로 개인정보의 중요성 등에 관한 교육 훈련을 실시합니다. 회사는 또한 이러한 훈련에 대한 기록을 유지합니다.'
    },
    policy7: {
      title: '개인 데이터 처리와 관련된 고객 권리',
      description:
        '2016년 4월 27일자 EU 일반 데이터 보호 규정(GDPR) 2016/679에 기반하여 고객은 개인 데이터 처리와 관련하여 다음 권리를 가집니다:',
      right1: '접근 권',
      right2: '정정 권',
      right3: '삭제 권(잊혀질 권리) 및 처리 제한 권',
      right4: '데이터 포호드/성 권',
      right5: '이의 제기 권',
      right6: '프로파일링을 포함한 자동화된 처리 기반 결정에 종속되지 않을 권.'
    },
    policy8: {
      title: '공개, 정정, 이용 중단 등의 요청',
      description1:
        '회사는 고객이 보유한 개인 데이터의 이용 목적 통지 요청, 공개 요청, 정정/추가/삭제 요청, 이용 중단/삭제 요청 및 제3자 제공 중단 요청(총칭하여 "공개 등의 요청")에 대해 아래 11절에 명시된 연락처를 통해 대응합니다.',
      description2:
        '또한 회사는 고객의 계정 페이지에서 회원 정보 변경 및 확인과 이메일 매거진 배포 중단 등의 고객 요청에 응합니다.'
    },
    policy9: {
      title: '외부 링크',
      description:
        'LINKTIVITY 홈페이지에는 다른 웹사이트로의 링크가 포함되어 있습니다. 본 개인정보 처리방침은 LINKTIVITY 홈페이지를 통해 수집된 정보에만 적용되며, 회사는 다른 웹사이트의 개인정보 처리방침 또는 콘텐츠에 대해 책임을 지지 않습니다. 고객은 링크된 웹사이트의 개인정보 처리방침을 읽고 개인정보가 어떻게 처리되는지 확인하도록 요청됩니다.'
    },
    policy10: {
      title: '개인정보 처리방침 변경',
      description:
        '회사는 본 개인정보 처리방침을 LINKTIVITY 홈페이지에 게시하여 고객이 회사가 어떤 개인정보를 수집하고 무엇을 위해 수집하고 어떻게 사용하는지 항상 알 수 있도록 합니다. 개인정보 처리방침의 변경도 LINKTIVITY 홈페이지에 게시되고 고객에게 공개됩니다.'
    },
    policy11: {
      title: '연락처',
      description1:
        '회사의 개인정보 처리방침, 회사의 개인정보 보호 노력, 고객 개인정보 수집 및 사용 또는 공개 등의 요청과 관련된 질문은 아래 연락처 양식을 사용하십시오. 담당자가 5영업일 이내에 응답하겠습니다.',
      company: 'Linktivity Inc.',
      address:
        '일본 도쿄도 치요다구 우치사이와이초 2-1-6 히비야 파크프론트 19층',
      dpoContact: '데이터 보호 담당자 연락처: dpo@linktivity.co.jp'
    },
    contentLabels: {
      acquisitionOfPersonalInfo: '수집된 개인정보',
      specificPurpose: '구체적인 이용 목적',
      legalBasis: '법적 근거:',
      provisionMethod: '제공 방법'
    }
  },
  terms: {
    title: 'LINKTIVITY利用規約',
    lastUpdated: '最終更新日 2020年05月01日',
    intro: {
      company: 'リンクティビティ株式会社（以下、「当社」といいます）は、',
      serviceDesc:
        'のサービスのご利用に関して、以下のとおりLINKTIVITY利用規約（以下、「本規約」といいます）を定めています。',
      agreement:
        'LINKTIVITYをご利用いただいた場合は、本規約に同意したものとみなしますので、LINKTIVITYのサービスをご利用いただきます際には、必ず本規約をお読みください。なお、本規約は、必要に応じ変更することがございますので、ご利用の際には最新の内容をご参照ください。',
      privacyNote: '＊個人情報の取り扱いについては、',
      privacyLinkText: '「個人情報保護方針」',
      privacyNoteSuffix: 'をお読みください。'
    },
    article1: {
      title: '第一条 規約の目的',
      content:
        '本規約は当社が運営する商品・サービス等の場貸し（プラットフォーム）販売サイト「LINKTIVITY」のサービス利用者に適用するものです。本サービスの利用者は、あらかじめ本規約に同意した上で、本サービスを利用するものとします。また、本規約は予告なく変更することがあります。'
    },
    article2: {
      title: '第二条 会員登録',
      items: [
        '「会員」とは、本規約を承認の上、本規約に基づき本サービスの提供を受けるために当社の指定する会員登録手続を完了し、当社が会員として承認した個人とします。ただし、承認後でも、当社が会員として不適当と判断した場合には承認の取り消しを行うことがあります。',
        '会員登録の際の登録情報に関して、いかなる虚偽の申告も認めないものとします。本人、登録情報（氏名、メールアドレス等）、パスワードは、それぞれ一つずつのみ対応するものとし、同一人物による複数の会員としての登録は認めないものとします。',
        '登録情報に変更が生じた場合は、会員は速やかに所定の変更手続きを行うものとします。'
      ]
    },
    article3: {
      title: '第三条 商品提供者が提供する情報',
      content:
        '当社は、LINKTIVITYにおいて、商品提供者が提供する内容、料金、購入可能日時、取消規定（キャンセルポリシー）等購入に必要な情報(以下、「購入関連情報」といいます)、および商品提供者に関する情報を会員に提供しますが、購入関連情報は、商品提供者の責任において提供されるものであり、当社が故意または過失による情報の非伝達のため発生したものを除き、当社は情報の内容については一切責任を負うものではありません。'
    },
    article4: {
      title: '第四条 契約成立',
      content:
        'LINKTIVITYのプラットフォームでは会員が購入する商品、サービス等の提供に関する契約は、会員と商品提供者との間で直接締結されます。LINKTIVITYにおける商品、サービス等の掲載は、商品提供者への申し込みを行うためのものであり、当社はその申し込みを当該商品提供者に代わって自由に承認または却下できます。本利用規約は、会員によるLINKTIVITYサービスの使用を規定するものであり、商品提供者への購入申し込みを行うためにLINKTIVITYを使用する場合も含みます ただし、会員が予約する商品・サービス等の提供は、LINKTIVITYに表示される契約条件、予約手続中に提示される情報、およびプ商品・サービス等の提供に関する法的な契約の締結先である商品提供者が定める契約条件に従うものとします。'
    },
    article5: {
      title: '第五条 代金のお支払',
      content: [
        'LINKTIVITYは商品提供者の代金回収代理業者として、会員のお支払い情報を取得し、支払いを処理します。会員は、商品・サービス等の購入時に当社へクレジットカードまたは当社が提供する決済手段にて代金を支払うものとします。外貨表記ので、当社が日本円でクレジットカード決済額または当社が提供する決済手段の請求金額を決定する場合は、当社が定めるレートにて日本円に換算することとします。',
        '但し、一部については、ページで指定された次のいずれかの方法で支払うものとします。'
      ]
    },
    article6: {
      title: '第六条 商品提供者が提供する商品・サービスの内容・品質',
      content:
        '当社は、商品提供者が提供する商品・サービスの内容・品質については一切責任を負うものではなく、会員と商品提供者との間で生じるトラブル、紛争もしくは苦情、会員が被る損害については、会員が商品提供者との間で解決するものとし、当社はこれらにつき何ら責任を負うものではありません。'
    },
    article7: {
      title: '第七条 利用環境',
      items: [
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の購入に必要な通信機器・ソフトウェア・通信手段等必要なものの全てを用意するものとします。',
        '会員は、LINKTIVITYの利用に際して自己の費用と責任において、商品・サービス等の利用に必要なインターネットに接続可能なスマートフォン・ソフトウェア・通信手段等必要なものの全てを用意するものとします。'
      ]
    },
    article8: {
      title: '第八条 会員の自己都合による購入の取消、取消料',
      items: [
        '会員の自己都合で購入を取消す場合の取消料は、該当商品提供者が定める取消規約（キャンセルポリシー）に則ります。',
        '当社は代金支払時と代金返金時の為替差損益については一切責任を負うものではありません。',
        '購入の取消は、原則、LINKTIVITYのマイページより行うものとします。但し、利用日直前で、商品提供者に直接電話で連絡がとれ、かつ商品提供者が購入の取消を受付けた場合は、後日、マイページよりLINKTIVITYへ、その旨連絡することにより取消手続きは完了するものとします。'
      ]
    },
    article9: {
      title: '第九条 商品提供者による取消、返金',
      content:
        '商品・サービス等の内容変更、中止に伴う会員への告知は商品提供者が行い、当社は商品・サービス等の変更、中止に伴なう責任は一切負いません。ただし、当社は商品提供者の決定・依頼に基づき販売した商品・サービス等の内容の変更や中止による商品・サービス等の払い戻し業務を代行する場合があります。'
    },
    article10: {
      title: '第十条 パスワードの管理',
      items: [
        '会員は、パスワードの管理責任を負うものとします。',
        '会員は、メールアドレス、パスワードを第三者に利用させたり、貸与、譲渡、名義変更、売買、質入等を行うことはできないものとします。',
        '会員のパスワードの管理不十分、使用上の過誤、第三者の使用等による損害の責任は、会員が負うものとし、当社は一切責任を負いません。'
      ]
    },
    article11: {
      title: '第十一条 会員登録情報の取扱い',
      items: [
        '会員登録の際に会員が登録した個人情報（以下、「登録情報」といいます）は、当社の個人情報保護方針に従い、当社が保有、管理するものとします。',
        {
          text: '当社は、登録情報のうち、特定の個人の識別が可能な情報（以下「個人情報」という。）を、第三者に開示しないものとします。ただし、以下の場合を除きます。',
          subItems: [
            '情報開示についてお客様の同意がある場合',
            '個人情報保護のための守秘義務契約を結んだ業務委託先に対しサービスを履行するために必要な個人情報を提供する場合',
            'サービス向上目的で個人情報を集計および分析し、個人を識別または特定できない状態で第三者に開示または提供する場合',
            '裁判所の発する令状その他裁判所の判断に従い開示する場合'
          ],
          note: 'なお、当社が取得した個人情報に関する、利用目的その他取り扱いについての詳細は「個人情報保護方針」をお読みください。'
        }
      ]
    },
    article12: {
      title: '第十二条 会員の禁止事項',
      intro:
        '会員は、LINKTIVITYを利用する際に、以下の行為またはそのおそれのある行為を行ってはならないものとします。',
      items: [
        '本規約に違反する行為',
        '公序良俗または法令に違反する行為',
        '当社、他の会員または第三者の著作権、肖像権、その他知的所有権を侵害する行為',
        '他の会員または第三者を誹謗・中傷する行為',
        '他の会員または第三者に不利益を与える行為',
        '当社の事業あるいは当社の提供するサービスの運営を妨害する行為',
        '営利を目的とする行為',
        '会員として得た権利を、当社の事前の同意を得ることなく第三者に譲渡および貸与する行為',
        'その他、当社が不適当と判断する行為'
      ]
    },
    article13: {
      title: '第十三条 会員発信情報の削除又は修正',
      intro:
        '当社は、会員が送信した情報のうち、以下のいずれかに該当するまたはそのおそれがあるものを、会員の承諾なく、全部または一部を削除し、またはこれに対し当社が必要と判断する修正を行うことができるものとします。',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当すると当社が判断するもの',
        '事実に明らかに反すると当社が判断するもの',
        'その他当社が不適当と判断するもの'
      ]
    },
    article14: {
      title: '第十四条 会員資格の抹消',
      intro:
        '会員が以下の事由のいずれかに該当する場合、当社は会員に事前の通知することなく、また会員に対して何らの責任を負うことなく、会員資格を抹消することができるものとします',
      items: [
        '本規約の「会員の禁止事項」のいずれかの事項に該当する行為を行った場合',
        'その他、本規約のいずれかに違反した場合。',
        'その他、会員として不適格と当社が判断した場合'
      ]
    },
    article15: {
      title: '第十五条 サービスの変更・中断・中止',
      items: [
        '当社は、会員に事前に通知することなく、サービス内容を変更、中断または中止する場合があります。',
        '本サービス内容の変更または中断に伴い、会員に不利益または損害が発生した場合であっても、当社はその責任を負わないものとします。',
        '当社は、会員に対して１ヶ月前に通知することにより、サービスの提供を中止することができるものとします。'
      ]
    },
    article16: {
      title: '第十六条 著作権および財産権',
      content:
        'LINKTIVITYに表示されるすべての内容に関する著作権および財産権は、当社および当社にそれらの内容を提供している、商品提供者、提携先、広告主に帰属しています。利用者および会員は、当社、商品提供者、提携先、広告主の事前の文書による承諾を受けた場合を除いて、それらの内容を複製、公開、譲渡、貸与、翻訳、転載、送信、使用許諾、再利用しないことなどに同意するものとします。また、利用者および会員がこれらの行為によって得た利益相当額を当社が請求できる権利を有していることとします。'
    },
    article17: {
      title: '第十七条 免責・責任制限',
      items: [
        '当社は、会員と商品提供者との間で生じた損害、会員が本規約に違反して生じた損害、商品・サービス等のチケットへの引き換えにおいて当社の責に帰さない事由により発生した損害については、一切の責任を負わないものとします。',
        '商品提供者は、当社とは独立した契約主体であり、商品提供者による、いかなる行為、過失、怠慢、代理行為、保証や、商品・サービス等の参加に関連する会員の負傷、死亡、所有物の損傷・遺失テロリズムに帰する損害、その他あらゆる損害等について、当社は一切責任を負うものではありません。',
        '当社は、当社の直接の管理範囲を超えた原因により生じた、商品・サービス等の遅延、キャンセル、重複購入、ストライキに対する責任を負わないものとします。また、政府当局や裁判所令状等による内容変更、キャンセル、遅延、追加費用の発生等についても応じる義務を負いません。',
        '当社は、当社に故意または過失がある場合においても、会員に対し、本サービスの提供に関連して会員に発生した現実かつ直接の通常損害以外の損害を負担しません。'
      ]
    },
    article18: {
      title: '第十八条 本規約の変更',
      content:
        '本規約の内容について、当社は必要に応じ変更できるものとします。本規約を変更した場合は、本画面上の変更をもってその変更が終了したものとし、都度、会員への通知は行わないものとします。'
    },
    article19: {
      title: '第十九条 合意管轄',
      content:
        '本規約に関する一切の紛争については、東京地方裁判所を第一審の専属管轄裁判所とします。'
    },
    article20: {
      title: '第二十条 協議',
      content:
        '本規約に定めのない事項又は本規約に関する疑義が生じた場合には、関係当事者間にて誠意をもって協議し、円満に解決するよう努めるものとします。'
    }
  },
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: '서비스명',
    companyName: '판매사업자',
    representative: '대표자명',
    address: '소재지',
    contact: '문의처',
    paymentTerms: '대금의 지급방법 및 지급시기',
    deliverySchedule: '상품의 인도시기',
    sellingPrice: '상품 등의 판매가격',
    shippingFee: '배송료',
    additionalFee: '판매가격・배송료 등 외에 필요한 요금',
    salesRestrictions: '판매기간・판매수량의 제한',
    returnsAndCancellations: '반품・취소',
    otherConditions: '기타 조건'
  },
  requireForm: {
    lastName: '성',
    firstName: '이름',
    participantInfo: '사용자 정보',
    requiredBookingInfo: '필요한 정보',
    BookingFieldMethod: {
      PER_PARTICIPANT: '각 참가자',
      PER_BOOKING: '각 예약'
    },
    bookingFields: {
      participantEmailAddress: '참가자 이메일 주소',
      hotelName: '호텔 이름',
      hotelAddress: '호텔 주소',
      hotelReservationLastName: '호텔 예약자 이름',
      hotelReservationFirstName: '호텔 예약자 성',
      hotelReservationName: '호텔 예약자',
      hotelTel: '호텔 전화 번호',
      arrivalDate: '도착 일자',
      arrivalTime: '도착 시간',
      arrivalFlightNumber: '도착 항공편 편명',
      departureDate: '출발 일자',
      departureTime: '출발 시간',
      departureFlightNumber: '출발 비행편명',
      destinationEmail: '현지에서 연락 가능한 이메일',
      destinationTel: '현지에서 연락 가능한 전화번호',
      gender: '성별',
      agentChannelRegion: '여행대리점 지역',
      agentChannelLanguage: '여행대리점 언어',
      participantResidentRegion: '참가자 거주 지역',
      participantLanguage: '참가자 언어',
      passengersQuantity: '승차 인원수',
      prescriptionMaskQuantityFree: '도수 마스크(무료)',
      prescriptionMaskQuantityPaid: '도수 마스크(유료, 현지 지불)',
      preferredStartTime: '희망 시작 시간',
      preferredPickUpLocation: '픽업 및 승차 장소',
      preferredDropOffLocation: '샌딩 및 하차 장소',
      participantsQuantity: '참가자 인원수',
      luggageQuantity: '수하물(캐리어)의 개수',
      childrenWithoutSeatQuantity: '좌석이 필요없는 유아의 인원수',
      childSeatQuantityPaid: '유아용 카시트 이용 개수(유료, 현지 지불)',
      childSeatQuantityFree: '유아용 카시트 이용 개수(무료)',
      guideJa: '일본어 가이드 희망',
      driverJa: '일본어 드라이버 희망',
      guideEn: '영어 가이드 희망',
      driverEn: '영어 드라이버 희망',
      guideZh: '중국어 가이드 희망',
      driverZh: '중국어 드라이버 희망',
      guideKo: '한국어 가이드 희망',
      driverKo: '한국어 드라이버 희망',
      preferredGuideLanguageCode: '희망 가이드 언어',
      preferredDriverLanguageCode: '희망 드라이버 언어',
      passportNationality: '국적',
      passportFirstName: '참가자 이름(여권과 동일한 영문으로 기입)',
      passportLastName: '참가자 성(여권과 동일한 영문으로 기입)',
      dateOfBirth: '생년월일',
      age: '나이',
      passportNumber: '여권 번호',
      eyesight: '시력',
      weightKg: '체중(kg)',
      heightCm: '신장(cm)',
      shoeSizeCm: '신발 사이즈(cm)',
      weightLbs: '체중(lbs)',
      heightIn: '신장(ft/in)',
      clothesSize: '옷 사이즈',
      vegetarianMeals: '베지테리안 음식 희망',
      divingExperienceTimes: '다이빙 경험수',
      rentalEquipmentsFree: '장비 대여 희망(무료)',
      rentalEquipmentsPayLocally: '장비 대여 희망(유료, 현지 지불)',
      male: '남성',
      female: '여성',
      other: '기타',
      yes: '예',
      no: '아니요'
    }
  },
  components: {
    selectOption: {
      title: '옵션',
      quantity: '수량: {{quantity}}',
      addCart: '장바구니에 추가',
      planSelect: '플랜을 선택',
      dateSelect: '날짜를 선택',
      dateLabel: '날짜',
      timeSelect: '시간을 선택',
      quantitySelect: '수량을 선택',
      quantitySelectLabel: '수량',
      soldOut: '품절',
      total: '합계',
      viewDetail: '상세 보기',
      unitRatioNotCounted: '※이 옵션은 합계 수량에 포함되지 않습니다',
      unitRatioCounted: '※1개당 {{quantity}}명분으로 계산됩니다'
    },
    planDetailDrawer: {
      title: '플랜 상세',
      planContent: '플랜 내용',
      meetingPlace: '집합 장소',
      cancellationPolicy: '취소 정책',
      capacity: '예약 가능 수',
      maxCapacity: '최대 예약 가능 수',
      minCapacity: '최소 예약 가능 수',
      bookingAcceptance: '예약 가능 기간',
      bookingDeadline: '예약 접수 마감',
      voucherExpirationPeriod: '바우처 유효 기간',
      inclusion: '포함 사항',
      participationLocations: '참가 장소',
      participationLocationKind: {
        MAP_OF_MEETING_POINT: '장소 설명',
        NOTE_OF_LOCATION_AND_DIRECTION: '장소, 가는 방법 보충 설명',
        LANDMARKS_TO_MEETING_POINT: '체크인 장소의 근처 명소',
        PICK_UP_CAR: '픽업 차량',
        PICK_UP_GUIDE: '픽업 가이드',
        ITINERARY: '일정',
        PARKING: '주차장 정보'
      },
      restrictions: '참가 제한',
      requirements: '참가 전·참가 시 필요한 사항',
      attireItems: '참가 시 필요한 복장·소지품',
      otherInfo: '비고·기타'
    },
    payment: {
      ticket: '티켓',
      option: '옵션',
      total: '합계 (세액 포함)',
      details: '상세',
      submit: '주문하기'
    },
    bookInfo: {
      plan: '플랜',
      dateTime: '날짜 및 시간',
      validityPeriod: '유효 기간',
      ticket: '티켓',
      option: '옵션',
      discount: '할인',
      total: '합계 (세액 포함)'
    },
    coupon: {
      title: '쿠폰',
      caption: '쿠폰을 적용하려면 쿠폰 코드를 입력하세요.',
      apply: '적용'
    },
    bookingDetailVoucher: {
      pdf: '출력용 PDF',
      html: '바우처'
    },
    collapsibleCard: {
      stockStatus: {
        available: '판매중',
        limited: '잔여 적음',
        soldOut: '매진'
      }
    },
    unitCard: {
      minCapacityWarning:
        '최소 구매 수량은 {{quantity}}개입니다. 수량을 확인해 주세요.',
      maxCapacityReached: '구매 한도에 도달했습니다',
      optionQuantityLimitReached:
        '현재 선택 내용으로는 이 옵션을 추가할 수 없습니다'
    }
  },
  bookingDetail: {
    title: '예약 상세',
    meetingPoint: '입장 위치 안내',
    beforeTrip: '이용 전 확인 사항',
    reservationInfo: '예약 정보',
    redemption: 'E-티켓 사용',
    digitalTicketWaiting: '*주문 확인 후 전자 티켓이 여기에 표시됩니다',
    inclusion: '포함된 물품',
    restrictions: '참가 제한',
    requirements: '참가 전 및 참가 중 필요 사항',
    attireItems: '참가 시 필요 의복 및 소지품',
    otherInfo: '비고·기타',
    cancelSuccess: '예약을 취소하였습니다.',
    sendToEmailSuccess: '이메일 전송 성공, 받은 편지함을 확인해 주세요',
    sendToEmailError: '이메일 전송에 실패했습니다. 잠시 후 다시 시도해 주세요'
  },
  bookResult: {
    pendingTitle: '결제를 확인 중입니다',
    pendingMessage:
      '주문이 아직 완료되지 않았습니다. 처리가 완료될 때까지 기다려 주세요.',
    successMessage:
      '예약해 주셔서 감사합니다. 예약 바우처는 지금 등록한 이메일 주소로 발송됩니다, 받은 편지함을 확인해 주세요.',
    failedMessage: '결제에 실패했습니다. 다시 예약해 주세요.',
    timeoutMessage:
      '시간이 초과되었습니다. 사이트를 새로고침 하거나, 이메일 또는 예약 정보에서 예약이 정상적으로 처리되었는지 확인하여 주시기 바랍니다.',
    backToProduct: '상품으로 돌아가기'
  },
  booking: {
    title: '예약 정보',
    bookingNumber: '예약 번호',
    viewDetail: '예약 정보 보기',
    toBooking: '다시 예약',
    bookingRange: {
      oneMonth: '1개월 이내 예약',
      threeMonths: '3개월 이내 예약',
      sixMonths: '6개월 이내 예약'
    },
    plan: '플랜',
    participationTime: '참여 일시',
    validityPeriod: '유효 기간',
    count: '수량',
    option: '옵션',
    paidAmount: '결제 금액',
    customerName: '예약자명',
    refundAmount: '환불 금액',
    orderCompletionTime: '예약 시간',
    adultTicket: '성인',
    childTicket: '어린이',
    status: {
      BOOKING_STATUS_CONFIRMED: '예약 완료',
      BOOKING_STATUS_PENDING: '예약 절차 완료（발권 확인 중）',
      BOOKING_STATUS_CANCEL_PENDING: '취소 중',
      BOOKING_STATUS_CANCELED: '취소됨',
      BOOKING_STATUS_USED: '사용됨',
      BOOKING_STATUS_WITHDRAWN: '예약이 성립되지 않았습니다',
      BOOKING_STATUS_APPLIED: '추첨 신청 접수 완료',
      BOOKING_STATUS_APPLIED_DECLINED: '추첨 신청 탈락',
      BOOKING_STATUS_DECLINED: '추첨 신청 탈락'
    }
  }
};
